// src/stores/useCountyNamesStore.js
//
// Manages the county-NAME label layer visibility, independent of which
// boundary grid (county boundaries / GLO survey) is showing.
//
// Why its own store, separate from useCountyLayerStore:
//   - County BOUNDARIES (lines) and the GLO survey grid are a mutually
//     exclusive pair (at most one on). That logic lives in the toggle
//     handlers, coordinating useCountyLayerStore + useGloStore.
//   - County NAMES are an orientation aid that is valid regardless of
//     which boundary framework — or none — is displayed. They are NOT
//     part of the mutual-exclusion pair and must not be coupled to it.
//   - Modeled on useGloStore / useCountyLayerStore for shape consistency.
//
// Default: ON. County names are lightweight orientation context; the
// client symbol layer applies a minzoom floor + collision culling so
// they never become low-zoom label-soup. A user who wants a clean map
// can turn them off via the Reference tab.
 
import { create } from "zustand";
 
export const useCountyNamesStore = create((set) => ({
  countyNamesVisible: true,
  toggleCountyNames: () =>
    set((s) => ({ countyNamesVisible: !s.countyNamesVisible })),
  setCountyNamesVisible: (v) => set({ countyNamesVisible: v }),
}));
 